var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 17.65,
    y1: 26.056,
    x2: 21.099,
    y2: 26.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 17.65,
    y1: 23.756,
    x2: 21.099,
    y2: 23.756,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 17.65,
    y1: 21.456,
    x2: 21.099,
    y2: 21.456,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 17.65,
    y1: 19.156,
    x2: 21.099,
    y2: 19.156,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 17.65,
    y1: 16.857,
    x2: 21.099,
    y2: 16.857,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 17.65,
    y1: 14.557,
    x2: 21.099,
    y2: 14.557,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 17.65,
    y1: 12.257,
    x2: 21.099,
    y2: 12.257,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 17.65,
    y1: 9.957,
    x2: 21.099,
    y2: 9.957,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 17.65,
    y1: 7.657,
    x2: 21.099,
    y2: 7.657,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 16.237,
    y1: 27.217,
    x2: 19.686,
    y2: 27.217,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 16.237,
    y1: 24.918,
    x2: 19.686,
    y2: 24.918,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 16.237,
    y1: 22.618,
    x2: 19.686,
    y2: 22.618,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 16.237,
    y1: 20.318,
    x2: 19.686,
    y2: 20.318,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 16.237,
    y1: 18.018,
    x2: 19.686,
    y2: 18.018,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 17.65,
    y1: 28.356,
    x2: 21.099,
    y2: 28.356,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 16.237,
    y1: 15.718,
    x2: 19.686,
    y2: 15.718,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 16.237,
    y1: 13.419,
    x2: 19.686,
    y2: 13.419,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 16.237,
    y1: 11.119,
    x2: 19.686,
    y2: 11.119,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 16.237,
    y1: 8.819,
    x2: 19.686,
    y2: 8.819,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 16.237,
    y1: 29.514,
    x2: 19.686,
    y2: 29.514,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 16.985,
    y1: 11.196,
    x2: 20.446,
    y2: 11.196,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 18.096,
    y1: 5.329,
    x2: 19.336,
    y2: 5.329,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 16.029,
    y1: 5.591,
    x2: 21.403,
    y2: 5.591,
    xlinkHref: "#a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_zip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.667,27.667V17.333L23,15V2H4.333V30H27.667Zm-4.667,0V18.556l2.333,1.222v7.889Z",
    style: {
      fill: "#c09553"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 25.559,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 23.26,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 20.96,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 18.66,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 16.36,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 14.06,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 11.76,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 9.461,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 7.161,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 26.721,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 24.421,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 22.121,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 19.821,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 17.522,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 27.859,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 15.222,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 12.922,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 10.622,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 8.322,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.237,
    y: 29.018,
    width: 3.45,
    height: 0.993,
    style: {
      fill: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,5.911a.554.554,0,0,0-.548-.53h-.009v.557h.092l.206,2.514H17.589L17.8,5.938h.094V5.381h-.044a.552.552,0,0,0-.547.53l-.314,10.569a.513.513,0,0,0,.515.531h2.432a.512.512,0,0,0,.513-.531Zm-1.384,10.5a1.171,1.171,0,1,1,1.171-1.171A1.171,1.171,0,0,1,18.716,16.408Z",
    style: {
      fill: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.096,
    y: 3.802,
    width: 1.24,
    height: 3.054,
    style: {
      fill: "url(#v)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4,4.56a2.549,2.549,0,0,0-2.549-2.549h-.276a2.55,2.55,0,0,0-2.436,3.3h0l0,.006v0A7.986,7.986,0,0,1,16.4,7.878H16.4a1.811,1.811,0,0,0,.641,1.271l.109-3.441a.593.593,0,0,1,.6-.551h.135V3.587h1.653v1.57h.1a.6.6,0,0,1,.605.551l.121,3.462a1.813,1.813,0,0,0,.666-1.292h0V7.8c0-.014,0-.027,0-.041s0-.026,0-.039a7.693,7.693,0,0,1,.236-2.359A2.543,2.543,0,0,0,21.4,4.56Z",
    style: {
      fill: "url(#w)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.d32dcd6ec003a6cd602ca7aebdf709f0.svg";
export { ForwardRef as ReactComponent };